import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EnhancedOrganizationHierarchy } from "../EnhancedOrganizationHierarchy";
import { VisualOrganizationHierarchy } from "../VisualOrganizationHierarchy";

interface HierarchyTabProps {
  organizationId: string;
}

export function HierarchyTab({ organizationId }: HierarchyTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Organization Hierarchy</CardTitle>
        <CardDescription>
          View hierarchical relationships and metrics for this organization
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="visual" className="w-full">
          <TabsList className="mb-4">
            <TabsTrigger value="visual">Visual Chart</TabsTrigger>
            <TabsTrigger value="tree">Tree View</TabsTrigger>
          </TabsList>
          
          <TabsContent value="visual" className="mt-0">
            <VisualOrganizationHierarchy 
              organizationId={organizationId}
              className="h-[600px]"
            />
          </TabsContent>
          
          <TabsContent value="tree" className="mt-0">
            <EnhancedOrganizationHierarchy 
              organizationId={organizationId}
              showControls={true}
              showSearch={true}
              showMetrics={true}
              initialView="tree"
              defaultDepth={3}
              initiallyExpanded={true}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}